










import Vue from "vue";
export default Vue.extend({
  name: "c-field",
  props: ["label"]
});
